import { Card } from '@mint-lib/tw-components';

const BarContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Card className="mt-4 mb-4 w-full">
      <div className="flex items-center justify-between">{children}</div>
    </Card>
  );
};

export default BarContainer;
